import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdminMenuService {

  constructor(private http: HttpClient) { }

  serviceBaseURL: string = environment.serviceBaseUrl;

  getMenu(): Promise<any> {
    return this.http.get(this.serviceBaseURL + 'Kesavi/GetMenu').toPromise();
  }

  addMenu(obj): Promise<any> {
    return this.http.post(this.serviceBaseURL + 'Kesavi/AddMenu', obj).toPromise();
  }

  editMenu(obj): Promise<any> {
    return this.http.post(this.serviceBaseURL + 'Kesavi/UpdateMenu', obj).toPromise();
  }

  deleteMenu(Id): Promise<any> {
    return this.http.get(this.serviceBaseURL + 'Kesavi/DeleteMenu/' + Id).toPromise();
  }


  getHeading(): Promise<any> {
    return this.http.get(this.serviceBaseURL + 'Kesavi/GetHeading').toPromise();
  }

  addHeading(obj): Promise<any> {
    return this.http.post(this.serviceBaseURL + 'Kesavi/AddHeading', obj).toPromise();
  }

  editHeading(obj): Promise<any> {
    return this.http.post(this.serviceBaseURL + 'Kesavi/UpdateHeading', obj).toPromise();
  }

  deleteHeading(Id): Promise<any> {
    return this.http.get(this.serviceBaseURL + 'Kesavi/DeleteHeading/' + Id).toPromise();
  }


  getSubMenuLinks(): Promise<any> {
    return this.http.get(this.serviceBaseURL + 'Kesavi/GetSubMenuLinks').toPromise();
  }

  addSubMenuLinks(obj): Promise<any> {
    return this.http.post(this.serviceBaseURL + 'Kesavi/AddSubMenuLinks', obj).toPromise();
  }

  editSubMenuLinks(obj): Promise<any> {
    return this.http.post(this.serviceBaseURL + 'Kesavi/UpdateSubMenuLinks', obj).toPromise();
  }

  deleteSubMenuLinks(Id): Promise<any> {
    return this.http.get(this.serviceBaseURL + 'Kesavi/DeleteSubMenuLinks/' + Id).toPromise();
  }
}
